import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=5cfdaf02&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cfdaf02')) {
      api.createRecord('5cfdaf02', component.options)
    } else {
      api.reload('5cfdaf02', component.options)
    }
    module.hot.accept("./Add.vue?vue&type=template&id=5cfdaf02&", function () {
      api.rerender('5cfdaf02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Device/Add.vue"
export default component.exports